import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';
import { IModalWindow, MODAL_TYPE, ModalWindow } from '../../modal/ModalWindow';
import { scrollToError } from '../../../utils/formikUtils';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { setQuickApplication } from '../../../store/merchnts/actions/quick-application';
import { IFeeData } from '../../merchants/FeeTableRow';
import { useNavigate } from 'react-router-dom';
import { APPLICATION_DETAILS_NAVIGATION } from '../../../constants/application-details/application-details-navigation';
import {
  QUICK_APPLICATION_FORM_FIELDS
} from '../../../constants/new-application/quick-application/quick-application-form';

interface Props {
  formik: any;
  activeFee?: IFeeData;
  nonStandardFee?: IFeeData;
}

export const QuickApplicationFooter: FC<Props> = (props) => {
  const { formik } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { merchantState, dispatch } = useMerchants();
  const { isQuickApplicationLoading } = merchantState;

  const [modalState, setModalState] = useState<IModalWindow>({
    isOpen: false
  });

  const [saveModalOpen, setSaveModalOpen] = useState<boolean>(false);

  const onCloseModal = (): void => navigate(`/accounts/applications`);
  const closeSaveModal = (): void => setSaveModalOpen(false);

  const handleSuccessModal = (applicationId: string, isSend?:boolean): void => {
    setSaveModalOpen(false);
    setModalState({
      isOpen: true,
      modalTitle: 'Application created',
      modalType: MODAL_TYPE.APPROVE,
      content: <CreateNewApplicationSuccessContent isSend={isSend} email={formik.values[QUICK_APPLICATION_FORM_FIELDS.EMAIL]}/>,
      confirmButtonText: 'To application',
      onConfirm: (): void => navigate(`/accounts/applications/${applicationId}/${APPLICATION_DETAILS_NAVIGATION.FORM}`),
      cancelButtonText: 'Back to list',
      onCancel: (): void => navigate(`/accounts/applications`),
    });
  };

  const handleSave = async (): Promise<void> => {
    formik.handleSubmit();
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      await setQuickApplication({
        dispatch,
        formik,
        onSuccess: handleSuccessModal
      });
    } else {
      scrollToError(errors);
    }
  };
  const handleSaveAndSendButtonClick = async (): Promise<void> => {
    formik.handleSubmit();
    const errors = await formik.validateForm();
    console.log('errors', errors);
    if (Object.keys(errors).length === 0) {
      setSaveModalOpen(true);
    } else {
      scrollToError(errors);
    }
  };
  return (
    <>
      <div className="d-sm-flex align-items-center justify-content-end">
        <ButtonComponent
          buttonType={BUTTON_TYPE.WHITE}
          buttonName={t('NEW_APPLICATION.SAVE_BUTTON')}
          additionalClass="me-sm-5 mb-5 mb-sm-0 save-btn-width d-block w-100 d-sm-inline-block w-sm-auto"
          onButtonClick={handleSave}
          isDisabled={isQuickApplicationLoading}
          loading={isQuickApplicationLoading}
        />

        <ButtonComponent
          buttonName={t('NEW_APPLICATION.SAVE_AND_SEND_BUTTON')}
          additionalClass="mb-5 mb-sm-0 btn-sm d-block w-100 d-sm-inline-block w-sm-auto"
          onButtonClick={handleSaveAndSendButtonClick}
          isDisabled={isQuickApplicationLoading}
        />
      </div>

      <ModalWindow
        {...modalState}
        onClose={onCloseModal}
      />

      <ModalWindow
        isOpen={saveModalOpen}
        modalType={MODAL_TYPE.SAVE}
        modalText={t('NEW_APPLICATION.SEND_APP_TEXT')}
        modalTitle={t('NEW_APPLICATION.SEND_APP_TITLE')}
        onClose={closeSaveModal}
        onCancel={closeSaveModal}
        onConfirm={async (): Promise<void> => {
          await setQuickApplication({
            dispatch,
            formik,
            onSuccess: handleSuccessModal,
            isSaveAndSend: true
          });
          closeSaveModal();
        }}
      />
    </>
  );
};

interface ContentProps {
  email: string;
  isSend: boolean;
}

export const CreateNewApplicationSuccessContent: FC<ContentProps> = (props) => {
  const { t } = useTranslation();
  const { isSend, email } = props;

  return (
    <div className="fs-5 mb-10 px-8">
      <div className="mb-5 fw-bolder text-center">
        {
          isSend
            ? t('QUICK_APPLICATION.SUCCESS_MODAL_TITLE_WITH_INVITATION')
            : t('QUICK_APPLICATION.SUCCESS_MODAL_TITLE_WITHOUT_INVITATION')
        }
      </div>
      <div className="mb-10">
        {
          isSend
            ? (
              <>
                {/*Space is needed in text! Don't remove*/}
                <span>{t('QUICK_APPLICATION.SUCCESS_MODAL_TEXT_WITH_INVITATION_P1')} </span>
                {/*Space is needed in text! Don't remove*/}
                <span className="fw-bolder">{email} </span>
                <span>{t('QUICK_APPLICATION.SUCCESS_MODAL_TEXT_WITH_INVITATION_P2')}</span>
              </>
            )
            : (
              <>
                {/*Space is needed in text! Don't remove*/}
                <span>{t('QUICK_APPLICATION.SUCCESS_MODAL_TEXT_WITHOUT_INVITATION_P1')} </span>
                {/*Space is needed in text! Don't remove*/}
                <span className="fw-bolder">{email} </span>
                <span>{t('QUICK_APPLICATION.SUCCESS_MODAL_TEXT_WITHOUT_INVITATION_P2')}</span>
              </>
            )
        }
      </div>

      <div>
        <span className="fw-bolder">Note: </span>
        <span>
              {
                isSend
                  ? t('QUICK_APPLICATION.SUCCESS_MODAL_NOTE_WITH_INVITATION')
                  : t('QUICK_APPLICATION.SUCCESS_MODAL_NOTE_WITHOUT_INVITATION')
              }
            </span>
      </div>
    </div>
  );
};